export default __webpack_public_path__ + "justhatched-devices@2x.8e5ac80a.png";